import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Internship Attendance")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-5" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "col-md-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Institute", -1)
const _hoisted_16 = { class: "col-md-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Course", -1)
const _hoisted_18 = { class: "row mt-2" }
const _hoisted_19 = { class: "col-md-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Batch", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = { class: "col-md-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Term", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = { class: "col-md-3" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Trainee Registration", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = { class: "col-md-2 mt-2" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_30 = { key: 0 }
const _hoisted_31 = {
  id: "kt_info_update",
  class: "card shadow-none container-fluid px-0"
}
const _hoisted_32 = {
  class: "card-header bg-success text-light",
  id: "kt_info_update_header"
}
const _hoisted_33 = {
  style: {"padding":"21px","height":"90px"},
  class: "fw-bolder text-light my-auto"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_35 = {
  class: "card-body position-relative",
  id: "kt_info_update_body",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-wrappers": "#kt_info_update_body",
  "data-kt-scroll-dependencies": "#kt_info_update_header, #kt_info_update_footer",
  "data-kt-scroll-offset": "5px"
}
const _hoisted_36 = { class: "position-relative" }
const _hoisted_37 = { class: "scroll-y row" }
const _hoisted_38 = { class: "table table-row-dashed table-row-gray-600 align-middle gs-0 gy-4" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-dark" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "w-10px" }, "Selection"),
    /*#__PURE__*/_createElementVNode("th", { class: "w-10px" }, "Day"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Training Date"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Attendance Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Present"),
    /*#__PURE__*/_createElementVNode("th", null, "Late"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "In Time"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Out Time"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Remarks")
  ])
], -1)
const _hoisted_40 = ["onUpdate:modelValue"]
const _hoisted_41 = ["onUpdate:modelValue"]
const _hoisted_42 = ["onUpdate:modelValue"]
const _hoisted_43 = ["onUpdate:modelValue"]
const _hoisted_44 = ["onUpdate:modelValue"]
const _hoisted_45 = ["onUpdate:modelValue"]
const _hoisted_46 = {
  class: "card-footer py-5 text-left",
  id: "kt_info_update_footer"
}
const _hoisted_47 = ["data-kt-indicator"]
const _hoisted_48 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_49 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_50 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_time_select = _resolveComponent("el-time-select")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _hoisted_10,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    name: "tranche_id",
                    placeholder: "Select Tranche",
                    modelValue: _ctx.batch.tranche_id,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                    filterable: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches_info, (tranche) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: tranche.id,
                          label: tranche.label,
                          value: tranche.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tranche.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _hoisted_13,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Training Partner",
                    name: "entity_id",
                    modelValue: _ctx.batch.entity_id,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.entity_id) = $event)),
                    filterable: "",
                    style: {"width":"100%"},
                    onChange: _ctx.getTrainingInstitute
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (info) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: info.id,
                          label: 
                      '[' + info.entity_short_name + '] - ' + info.entity_name
                    ,
                          value: info.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString('[' + info.entity_short_name + '] - ' + info.entity_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Institute",
                    modelValue: _ctx.batch.institute_id,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.batch.institute_id) = $event)),
                    name: "institute_id",
                    filterable: "",
                    style: {"width":"100%"},
                    onChange: _ctx.courseInfo
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instituteList, (info) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: info.id,
                          label: info.institute_name,
                          value: info.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(info.institute_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Course",
                    modelValue: _ctx.batch.course_id,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.batch.course_id) = $event)),
                    name: "course_id",
                    filterable: "",
                    style: {"width":"100%"},
                    onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.batchInfo()))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseList, (info) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: info.id,
                          label: info.course_name,
                          value: info.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(info.course_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _hoisted_21,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Batch",
                    modelValue: _ctx.batch.batch_id,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.batch.batch_id) = $event)),
                    name: "batch_id",
                    filterable: "",
                    style: {"width":"100%"},
                    onChange: _ctx.termInfo
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.batchList, (info) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: info.id,
                          label: info.batch_sequence_number,
                          value: info.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(info.batch_sequence_number), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _hoisted_24,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Term",
                    modelValue: _ctx.batch.term_id,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.batch.term_id) = $event)),
                    name: "batch_id",
                    filterable: "",
                    style: {"width":"100%"},
                    onChange: _ctx.getTrainee
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.termList, (info) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: info.term_no,
                          label: info.term_no,
                          value: info.term_no
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(info.term_no), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _hoisted_27,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Trainee",
                    name: "trainee_id",
                    modelValue: _ctx.trainee_reg,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.trainee_reg) = $event)),
                    filterable: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.TraineeList, (info) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: info.id,
                          label: 
                      '[' +
                      info.registration_number +
                      '] - ' +
                      info.trainee_name
                    ,
                          value: info.registration_number
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString('[' +
                      info.registration_number +
                      '] - ' +
                      info.trainee_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("button", {
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.calenderDetails())),
                    type: "button",
                    class: "btn btn-success mt-6 p-3",
                    style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                  }, [
                    _createTextVNode(" Search "),
                    _hoisted_29
                  ])
                ])
              ])
            ])
          ])
        ])
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    (_ctx.showcalendarDetails)
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("h2", _hoisted_33, [
                _createElementVNode("span", null, "Trainee Name   :   " + _toDisplayString(_ctx.traineeInfo.trainee_name), 1),
                _createTextVNode(),
                _hoisted_34,
                _createElementVNode("span", null, "Registration No   :   " + _toDisplayString(_ctx.traineeInfo.registration_number), 1)
              ])
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createVNode(_component_el_form, {
                  model: _ctx.formData,
                  rules: _ctx.rules,
                  ref: "formRef"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("table", _hoisted_38, [
                        _hoisted_39,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attendanceList, (data, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                              _createElementVNode("td", null, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  value: "1",
                                  "onUpdate:modelValue": ($event: any) => ((data.day_selected) = $event)
                                }, null, 8, _hoisted_40), [
                                  [_vModelCheckbox, data.day_selected]
                                ])
                              ]),
                              _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                              _createElementVNode("td", null, [
                                _createVNode(_component_el_date_picker, {
                                  disabled: "",
                                  name: "training_date",
                                  "value-format": "YYYY-MM-DD",
                                  format: "DD-MM-YYYY",
                                  style: {"width":"100%"},
                                  modelValue: data.training_date,
                                  "onUpdate:modelValue": ($event: any) => ((data.training_date) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_el_date_picker, {
                                  name: "attendance_date",
                                  "value-format": "YYYY-MM-DD",
                                  format: "DD-MM-YYYY",
                                  style: {"width":"100%"},
                                  modelValue: data.attendance_date,
                                  "onUpdate:modelValue": ($event: any) => ((data.attendance_date) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _createElementVNode("td", null, [
                                _withDirectives(_createElementVNode("input", {
                                  checked: "",
                                  type: "checkbox",
                                  value: "1",
                                  "onUpdate:modelValue": ($event: any) => ((data.is_present) = $event)
                                }, null, 8, _hoisted_41), [
                                  [_vModelCheckbox, data.is_present]
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  value: "1",
                                  "onUpdate:modelValue": ($event: any) => ((data.is_late) = $event)
                                }, null, 8, _hoisted_42), [
                                  [_vModelCheckbox, data.is_late]
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                (_ctx.is24HourFormat(data.out_time))
                                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                      key: 0,
                                      type: "time",
                                      id: "in_time",
                                      name: "in_time",
                                      "onUpdate:modelValue": ($event: any) => ((data.in_time) = $event),
                                      style: {"border":"1px solid #1db78d","padding":"5px","border-radius":"4px"}
                                    }, null, 8, _hoisted_43)), [
                                      [_vModelText, data.in_time]
                                    ])
                                  : (_openBlock(), _createBlock(_component_el_time_select, {
                                      key: 1,
                                      modelValue: data.in_time,
                                      "onUpdate:modelValue": ($event: any) => ((data.in_time) = $event),
                                      name: "start_time",
                                      format: "HH:mm:ss",
                                      "value-format": "HH:mm:ss",
                                      placeholder: "In Time",
                                      style: {"width":"140px"}
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                              ]),
                              _createElementVNode("td", null, [
                                (_ctx.is24HourFormat(data.out_time))
                                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                      key: 0,
                                      type: "time",
                                      id: "out_time",
                                      name: "out_time",
                                      "onUpdate:modelValue": ($event: any) => ((data.out_time) = $event),
                                      style: {"border":"1px solid #1db78d","padding":"5px","border-radius":"4px"}
                                    }, null, 8, _hoisted_44)), [
                                      [_vModelText, data.out_time]
                                    ])
                                  : (_openBlock(), _createBlock(_component_el_time_select, {
                                      key: 1,
                                      modelValue: data.out_time,
                                      "onUpdate:modelValue": ($event: any) => ((data.out_time) = $event),
                                      name: "start_time",
                                      format: "HH:mm:ss",
                                      "value-format": "HH:mm:ss",
                                      placeholder: "In Time",
                                      style: {"width":"140px"}
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                              ]),
                              _createElementVNode("td", null, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-control form-control-sm text-right",
                                  type: "text",
                                  "onUpdate:modelValue": ($event: any) => ((data.remarks) = $event)
                                }, null, 8, _hoisted_45), [
                                  [_vModelText, data.remarks]
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_46, [
                      _createElementVNode("button", {
                        "data-kt-indicator": _ctx.loading ? 'on' : null,
                        class: "btn btn-lg btn-primary",
                        type: "button",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.formSubmit()))
                      }, [
                        (!_ctx.loading)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_48, [
                              _createTextVNode(" Submit "),
                              _createElementVNode("span", _hoisted_49, [
                                _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.loading)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_50, [
                              _createTextVNode(" Please wait... "),
                              _hoisted_51
                            ]))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_47)
                    ])), [
                      [_directive_loading, _ctx.load]
                    ])
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ])
            ])), [
              [_directive_loading, _ctx.load]
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}